import { render, staticRenderFns } from "./electionList.vue?vue&type=template&id=79e2e748&scoped=true&"
import script from "./electionList.vue?vue&type=script&lang=js&"
export * from "./electionList.vue?vue&type=script&lang=js&"
import style0 from "./electionList.vue?vue&type=style&index=0&id=79e2e748&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e2e748",
  null
  
)

export default component.exports